export default {
  addTitle: 'Add roster',
  vipLabel: 'VIP roster · assign to locked VIP seats',
  vipHint: 'Applies to everyone added in this session, manually or in bulk. When checked, they are assigned to available VIP seats automatically and stay unassigned if there are not enough.',
  manualTitle: 'Add participant manually',
  manualNamePlaceholder: 'Enter name',
  manualPhonePlaceholder: 'Enter phone (optional)',
  manualOrganizationPlaceholder: 'Enter organization (optional)',
  manualJobTitlePlaceholder: 'Enter job title (optional)',
  manualOrderPlaceholder: 'Smaller numbers go first',
  manualAdd: 'Add person',
  manualNameRequired: 'Please enter a name',
  manualOrderInvalid: 'Auto-fill order must be a positive integer',
  batchTitle: 'Bulk add',
  downloadTemplate: 'Download template (CSV)',
  upload: 'Upload roster',
  templateHint: 'Columns: name, phone (optional), organization, job title (optional), auto-fill order (optional; smaller numbers go first).',
  pendingCount: '{count} pending people',
  pendingTitle: 'Pending',
  pendingUnit: 'participants',
  invalidCount: '{count} invalid rows ignored',
  invalidRows: 'Invalid data on line {rows}',
  name: 'Name',
  phone: 'Phone',
  organization: 'Organization',
  jobTitle: 'Job title',
  autoFillOrder: 'Auto-fill order',
  remove: 'Remove',
  empty: 'No pending people',
  addButton: 'Add to registration roster',
  addSuccess: 'Roster added',
  parseFailed: 'Failed to parse CSV'
}
